<div class="px-5 py-3 flex flex-col gap-4 min-w-[480px] max-w-[700px]">
  <div class="flex justify-between items-center">
    <div class="text-xl font-semibold">
      {{ 'devices.detailTabs.activity.messageDialog.title' | translate }}
    </div>
    <button mat-icon-button class="-mt-1 -mr-2" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <pre
    class="bg-[#F5F5FA] rounded-lg p-4 text-sm overflow-auto max-h-[60vh] whitespace-pre-wrap break-all font-mono"
    >{{ formattedMessage }}</pre
  >

  <div class="flex justify-end">
    <button mat-flat-button (click)="dialogRef.close()">
      {{ 'general.btnClose' | translate }}
    </button>
  </div>
</div>
